import { useState } from "react";

const ITTicketModal = ({ equipment, equipmentList, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    equipment_id: equipment?.equipment_id || '',
    ticket_type: 'support',
    title: '',
    description: '',
    priority: 'normal'
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Novo Ticket de Suporte IT</h3>
          <p className="text-sm text-slate-400 mt-1">Reporte um problema ou solicite apoio técnico</p>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Equipamento</label>
            <select
              value={formData.equipment_id}
              onChange={e => setFormData({...formData, equipment_id: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="">Geral (sem equipamento específico)</option>
              {equipmentList.map(eq => (
                <option key={eq.equipment_id} value={eq.equipment_id}>
                  {eq.brand} {eq.model} - {eq.serial_number}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Tipo de Pedido</label>
            <select
              value={formData.ticket_type}
              onChange={e => setFormData({...formData, ticket_type: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="support">Suporte Técnico</option>
              <option value="repair">Reparação</option>
              <option value="replacement">Substituição</option>
              <option value="software">Instalação Software</option>
              <option value="other">Outro</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Assunto *</label>
            <input
              type="text"
              value={formData.title}
              onChange={e => setFormData({...formData, title: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              placeholder="Descreva brevemente o problema"
              data-testid="ticket-title"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Descrição Detalhada *</label>
            <textarea
              value={formData.description}
              onChange={e => setFormData({...formData, description: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              rows={4}
              placeholder="Descreva o problema em detalhe: quando começou, o que tentou fazer, mensagens de erro..."
              data-testid="ticket-description"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Prioridade</label>
            <select
              value={formData.priority}
              onChange={e => setFormData({...formData, priority: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="low">Baixa</option>
              <option value="normal">Normal</option>
              <option value="high">Alta</option>
              <option value="urgent">Urgente</option>
            </select>
          </div>
        </div>
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={() => onSave(formData)}
            disabled={!formData.title || !formData.description}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-50"
            data-testid="submit-ticket-btn"
          >
            Criar Ticket
          </button>
        </div>
      </div>
    </div>
  );
};

export default ITTicketModal;
